/**
 * Custom Dates Store
 * Manages global custom date state to prevent race conditions
 * Ensures date consistency across all components
 */
export const useCustomDatesStore = defineStore('CustomDatesStore', {
  state: () => ({
    isCustomDatesActive: false,
    customStartDate: null,
    customEndDate: null,
    sourceComponent: null,
    timestamp: null
  }),

  getters: {
    hasCustomDates: (state) =>
      state.isCustomDatesActive && state.customStartDate && state.customEndDate,

    getCustomDates: (state) =>
      state.hasCustomDates ? [state.customStartDate, state.customEndDate] : null,

    isActiveFor: (state) => (componentName) =>
      state.hasCustomDates && state.sourceComponent === componentName
  },

  actions: {
    setCustomDates(startDate, endDate, sourceComponent = 'unknown') {
      this.isCustomDatesActive = true
      this.customStartDate = startDate
      this.customEndDate = endDate
      this.sourceComponent = sourceComponent
      this.timestamp = Date.now()
      this.updateBookingStore()
    },

    clearCustomDates(sourceComponent = null, force = false) {
      if (force || !sourceComponent || sourceComponent === this.sourceComponent || !this.isCustomDatesActive) {
        this.isCustomDatesActive = false
        this.customStartDate = null
        this.customEndDate = null
        this.sourceComponent = null
        this.timestamp = null
      }
    },

    updateBookingStore() {
      if (this.hasCustomDates) {
        const bookStore = useBookStore()
        bookStore.startDate = this.customStartDate
        bookStore.endDate = this.customEndDate
      }
    },

    preventOverride(componentName) {
      return this.hasCustomDates && componentName !== this.sourceComponent
    },

    protectFromBookingStoreReset() {
      if (this.hasCustomDates) {
        nextTick(() => this.updateBookingStore())
      }
    }
  }
})
